import script from "./ComicDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ComicDetail.vue?vue&type=script&setup=true&lang=js"

import "@/features/comic/styles/ComicDetail.css?vue&type=style&index=0&lang=css&external"

const __exports__ = script;

export default __exports__